// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumbs_breadcrumb__6cu7Q"};